import './index.less';

import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  TextLabel,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

interface PreviewContent {
  name: string;
  template: string;
  sections: string;
  reportType: string;
  message?: string;
}

type PreviewContentKey = keyof PreviewContent;

const ReportPreviewModal = (props: {
  isPreviewOpen: boolean;
  onClose: (close: boolean) => void;
  data: PreviewContent;
}) => {
  const { t } = useTranslation();
  const labels: PreviewContentKey[] = [
    'name',
    'template',
    'sections',
    'reportType',
  ];

  return (
    <Modal
      closeOnEsc
      closeOnOutsideClick
      isClosable
      isOpen={props.isPreviewOpen}
      onClose={() => props.onClose(false)}
      size="md"
    >
      <ModalOverlay />
      <ModalContent className="previewContent">
        <ModalHeader>
          <Text className="title">{t('reportCommon.preview.title')}</Text>
        </ModalHeader>
        <ModalBody>
          <Text mb="5x">{t('reportCommon.preview.desc')}</Text>
          {props.data.message && (
            <>
              <Text mt="5x">================</Text>
              <Text>{props.data.message}</Text>
              <Text>================</Text>
              <br />
            </>
          )}
          {labels.map((label) => {
            return (
              <div className="item" key={`preview-${label}`}>
                <TextLabel className="label">
                  {t(`reportCommon.labels.${label}`)}:&nbsp;
                </TextLabel>
                <Text>{props.data[label]}</Text>
              </div>
            );
          })}
          <div className="item" key="previewGenerated">
            <TextLabel className="label">
              {t('reportCommon.labels.generated')}:&nbsp;
            </TextLabel>
            <Text>{t('reportCommon.preview.generated')}</Text>
          </div>
          <div className="item" key="previewDataRange">
            <TextLabel className="label">
              {t('reportCommon.labels.dateRange')}:&nbsp;
            </TextLabel>
            <Text>{t('reportCommon.preview.dataRange')}</Text>
          </div>
          <Text my="5x">================================</Text>
          <div className="item">
            {t('reportCommon.preview.download')}&nbsp;
            <Link>{t('reportCommon.preview.downloadLink')}</Link>
          </div>
          <Text>{t('reportCommon.preview.linkNote')}</Text>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => props.onClose(false)} minWidth="20x">
            {t('reportCommon.buttons.close')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ReportPreviewModal;
